import { apiGet, apiPatch } from './client'

export async function getAllAlerts(
  token: string,
  filters?: Record<string, any>,
) {
  const params = new URLSearchParams()
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, String(value))
      }
    })
  }
  const qs = params.toString()
  return apiGet(`/admin/alerts/all${qs ? `?${qs}` : ''}`, token)
}

export async function resolveAlert(token: string, alertId: string) {
  return apiPatch(`/admin/alerts/${alertId}/resolve`, token)
}
